module.exports = __webpack_public_path__ + "static/media/play.470649d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/play.svg
// module id = 713
// module chunks = 0